import React, { useRef, useEffect } from 'react';

import { useLayoutContext } from '@ott/layout-context';

import { S3_IMAGES_URL } from '../../../../constants';

import { motion, useInView, useAnimation } from 'framer-motion';

type Props = { className?: string };

const OrbitFive = ({ className }: Props) => {
  const ref = useRef(null);
  const inViewport = useInView(ref);
  const control = useAnimation();
  const { isDesktop } = useLayoutContext();

  const variants = {
    initial: isDesktop
      ? { opacity: 0, scale: 0 }
      : { opacity: 0, scale: 0, left: '50%', right: '50%', x: '-50%', y: '-5%' },
    animate: isDesktop
      ? {
          opacity: 0.7,
          scale: 1,
          transition: { duration: 1.42 },
        }
      : {
          opacity: 0.7,
          scale: 0.7,
          rotate: 15,
          transition: { duration: 1.42 },
        },
  };

  useEffect(() => {
    if (inViewport) {
      control.start('animate');
    }
  }, [control, inViewport, isDesktop]);

  return (
    <motion.svg
      ref={ref}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="1273"
      height="552"
      fill="none"
      variants={variants}
      initial="initial"
      animate={control}
    >
      <path
        id="orbitFive"
        stroke="url(#a)"
        strokeWidth="2"
        shapeRendering="geometricPrecision"
        d="M1268.84 445.642c-7.96 29.724-33.16 53.401-72.07 70.723-38.9 17.319-91.44 28.249-153.93 32.516-124.978 8.533-289.653-9.592-464.391-56.413-174.738-46.82-326.413-113.462-430.381-183.341-51.986-34.941-92.02-70.676-117.052-105.126C5.982 169.546-4 136.444 3.965 106.72c7.965-29.724 33.16-53.4 72.067-70.722 38.903-17.32 91.442-28.25 153.934-32.516 124.978-8.534 289.653 9.591 464.391 56.412s326.413 113.462 430.383 183.341c51.98 34.941 92.02 70.676 117.05 105.127 25.03 34.455 35.02 67.556 27.05 97.28Z"
      />
      <defs>
        <linearGradient
          id="a"
          x1="1151.98"
          x2="226.298"
          y1="31.807"
          y2="486.974"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EED7F1" />
          <stop offset=".085" stopColor="#FEFCFE" />
          <stop offset=".192" stopColor="#DBC1D4" />
          <stop offset=".285" stopColor="#6DD2E5" />
          <stop offset=".4" stopColor="#7BA0EB" />
          <stop offset=".51" stopColor="#BC86F6" />
          <stop offset=".632" stopColor="#DCC4F8" />
          <stop offset=".747" stopColor="#BFB5C6" />
          <stop offset=".87" stopColor="#F5F4F6" />
          <stop offset="1" stopColor="#D7CACE" />
        </linearGradient>
      </defs>
      <image
        href={`${S3_IMAGES_URL}planets_for_orbits/planet-5@2x.png`}
        width="50"
        height="50"
        x="500"
        y="450"
      >
        <mpath href="#orbitFive" />
      </image>
    </motion.svg>
  );
};

export default OrbitFive;
